module.exports = __webpack_public_path__ + "img/19.a5f02d09.png";